
import MembersMenu from '@/components/membership/MembersMenu.vue'
import environment from '@/helpers/Environment'
import store from '@/store/store'
import { Component, Vue } from 'vue-property-decorator'
import tenant from '@/helpers/Tenant'
import type { LogoURLs } from '@/types/ThemeOptions'

@Component({
  name: 'Header',
  components: { MembersMenu },
})
export default class extends Vue {
  get user() {
    return store.getters['Member/user']
  }

  get logoUrls(): LogoURLs {
    const logo = environment.sellerMeta?.logo || (tenant.theme?.logo)
    if (typeof logo === 'object') {
      return logo
    } else {
      return { large: logo || '/assets/sandbox/static/logo.svg' }
    }
  }

  get portalName() {
    return environment.portal.name
  }

  closeMemberMenu() {
    const memberMenu: Element = this.$refs.memberMenu as Element
    memberMenu.removeAttribute('open')
  }

  mounted() {
    //add event listener to elements other than those within the menu.
    const body = document.body
    body.addEventListener('click', (event) => {
      const memberMenu: Element = this.$refs.memberMenu as Element
      if (memberMenu && memberMenu.hasAttribute('open')) {
        //this excludes the buttons so the menu can close when an action is triggered.
        const isMemberMenuChild = Array.from(memberMenu.querySelectorAll('*:not(button)')).some(
          (x) => x === event.target,
        )
        if (!isMemberMenuChild) {
          this.closeMemberMenu()
        }
      }
    })
  }
}
